import React, { useEffect } from 'react';

const HistoryDate = (props) => {
  const { name } = props;
  if (!name) return null;

  const time = name.split('_')[0];
  const year = time.slice(0, 4);
  const month = time.slice(4, 6);
  const day = time.slice(6, 8);
  const hour = time.slice(8, 10);
  const minute = time.slice(10, 12);
  const hour1 = hour > 12 ? hour - 12 : hour;
  const ampm = hour >= 12 ? 'pm' : 'am';

  return <time dateTime={time}>{`${day}/${month}/${year} ${hour1}:${minute} ${ampm}`}</time>;
};

export default HistoryDate;
